import { Injectable }  from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class S3Service {

  constructor(
    private _http: HttpClient
  ) { }

  getObjectFromKey(key) {
    return this._http.get(environment.url + "/image?key=" + key, { headers: { "hideLoader": "true" }});
  }
}
